// extracted by mini-css-extract-plugin
export default {"content":"QWoj23","tooltip":"lew3Lo","tooltipAnimation":"PqkZOX","fadeOut":"gD4M7i","tooltipSensor":"diu3Aa","contentImg":"nawgsA","contentText":"k3jqWW"};